var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer-toolbar"},[_c('button-fill',{attrs:{"disabled":_vm.pendingTasksButtonDisabled,"disabled-label":"No pending tasks","label":_vm.pendingTasksButtonLabel,"size":"small","tag":"router-link","to":{
            name: 'workflow/pending',
            params: { clusterName: _vm.clusterName },
        }}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }